export default __webpack_public_path__ + "content/media/26.08e45120.jpg";